export const removeSpaces = str => {

    const regex = /\-/g;
    const rgx = new RegExp(regex);

    return str.replace(rgx, ' ');
};